import { render } from "./SlPricer.vue?vue&type=template&id=0ad6c480&scoped=true"
import script from "./SlPricer.vue?vue&type=script&lang=js"
export * from "./SlPricer.vue?vue&type=script&lang=js"

import "./SlPricer.vue?vue&type=style&index=0&id=0ad6c480&lang=scss&scoped=true"

import exportComponent from "/builds/fr.swissLife.nxtCms/cms/nxtcms/nxt-front-ui/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ad6c480"]])

export default __exports__